import { getEnumValues } from '@shared/utils/utils/enums';
import { CURRENT_LANGUAGE_LOCAL_STORAGE_KEY } from '../constants';
import { Language } from '../enums';

const CACHED_TRANSLATIONS_MAP = new Map<string, Object>();

export async function getRawTranslation(key: string, language?: Language, params?: Object): Promise<string> {
  if (!language) {
    try {
      const data: { [key: string]: string } = await chrome.storage.local.get([CURRENT_LANGUAGE_LOCAL_STORAGE_KEY]);
      language = data[CURRENT_LANGUAGE_LOCAL_STORAGE_KEY] as Language;
      console.log(`Got language from local storage: ${language}`);
    } catch {
      console.log('Failed to get language from local storage');
    }
    if (!language) {
      const browserLanguage: string = navigator.language || navigator.languages[0];
      language = browserLanguage.split('-')[0] as Language;
      if (!getEnumValues(Language).includes(language)) {
        language = Language.English;
      }
    }
  }
  const parts = key.split('.');
  const fileName = parts[0].replace(/_/g, '-');
  const path = `${chrome.runtime.getURL('assets')}/translations/${language}/${fileName}.${language}.json`;
  try {
    let data: Object;
    if (CACHED_TRANSLATIONS_MAP.has(path)) {
      data = CACHED_TRANSLATIONS_MAP.get(path)!;
    } else {
      const response: Response = await fetch(path);
      if (response.ok) {
        data = await response.json();
        CACHED_TRANSLATIONS_MAP.set(path, data);
      }
    }
    if (data) {
      let translation: string | Object = data;
      parts.forEach((part: string) => {
        translation = (translation as { [key: string]: string | Object })[part];
      });
      if (params) {
        Object.keys(params).forEach((paramKey: string) => {
          translation = (translation as string).replace(
            `{{${paramKey}}}`,
            (params as { [key: string]: string })[paramKey]
          );
        });
      }
      return translation as string;
    }
  } catch (ex) {
    console.error(`Failed to get translation: ${language} - ${key}`, ex);
  }
  return key;
}
